import React, { useEffect, useRef, useState } from 'react';
import Button from '../../ui/buttons/Button';
import Input from '../../ui/inputs/Input';
import Select from '../../ui/selects/Select';
import { FileText, Pen, Upload, X } from 'lucide-react';
import { useToast } from '../../ui/toast/ToastContext';
import SecondaryButton from '../../ui/buttons/SecondaryButton';
import { fetchWithCsrf } from '../../../utils/fetchWithCsrf';
import { snakecaseKeys } from '../../../utils/snakecaseKeys';
import ColorSelect from '../../ui/selects/ColorSelect';
import CustomModal from '../CustomModal';
import { camelizeKeys } from '../../../utils/camelizeKeys';

const EditBaseModal = ({ onClose, onSuccess, baseId }) => {
  const { addToast } = useToast();

  const [form, setForm] = useState({
    description: '',
    assetType: '',
    colorHex: '#7D48C7',
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    fetch(`/app/analyst/assets/bases/${baseId}`)
      .then((res) => res.json())
      .then((data) => {
        setForm(camelizeKeys(data));
        console.log('Base carregada', camelizeKeys(data));
      })
      .catch((err) => {
        console.error('Erro ao carregar base', err);
        addToast({ type: 'error', message: 'Erro ao carregar dados da base' });
      });
  }, [baseId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = snakecaseKeys({ base: form });

    try {
      const res = await fetchWithCsrf(`/app/analyst/assets/bases/${baseId}`, {
        method: 'PATCH',
        body: JSON.stringify(payload),
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      });

      if (!res.ok) {
        const json = await res.json();
        throw new Error(json.message || 'Erro ao atualizar base');
      }

      onClose();
      addToast({ type: 'success', message: 'Base atualizada com sucesso!' });
      onSuccess();
    } catch (err) {
      addToast({ type: 'error', message: err.message });
    }
  };

  return (
    <CustomModal onClose={onClose}>
      <div className="p-10" style={{ maxWidth: '720px' }}>
        {/* Header */}
        <div className="mb-6 flex items-center justify-between">
          <div className="flex items-center gap-3 text-blueDarker font-jost text-2xl font-semibold">
            <Pen size={24} className="text-tealMedium" strokeWidth={1.25} />
            Editar base
          </div>
          <button onClick={onClose} type="button">
            <X size={24} className="text-tealBase hover:opacity-80" strokeWidth={1.25} />
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="flex flex-col gap-4 font-jost text-sm">
          <div className="flex gap-4">
            <div className="w-64">
              <Input
                name="description"
                label="Nome da base"
                value={form.description}
                onChange={handleChange}
                required
              />
            </div>

            <div className="w-72">
              <Select
                name="baseType"
                label="Tipo da base"
                value={form.assetType}
                onChange={() => {
                  console.log('Tipo da base alterado');
                }}
                disabled
                options={[
                  { label: 'Fundos de Investimento', value: 'investment_funds' },
                  { label: 'Fundos de Previdência', value: 'pension_funds' },
                  { label: 'Renda Variável', value: 'equities' },
                ]}
                required
              />
            </div>

            <div className="w-20">
              <ColorSelect name="colorHex" label="Cor" value={form.colorHex} onChange={handleChange} required />
            </div>
          </div>

          {/* Actions */}
          <div className="flex justify-end items-center mt-1">
            <div className="flex justify-between gap-2">
              <SecondaryButton onClick={onClose} type="button">
                CANCELAR
              </SecondaryButton>
              <Button type="submit" disabled={isSubmitting}>
                {isSubmitting ? 'SALVANDO...' : 'SALVAR ALTERAÇÕES'}
              </Button>
            </div>
          </div>
        </form>
      </div>
    </CustomModal>
  );
};

export default EditBaseModal;
